import { DbJsonSchema } from '../dbJsonSchemas.js';
import { CrewClaimTypeEnum, crewClaimTypeEnumName, crewClaimTypeEnumPluralizedName, } from './crew.js';
/**
 * An extension of the `CrewClaimType`, but provided so that the two can have a little more interop.
 * Connects and bridges the Crew claim types and the GSP claim type.
 */
export const CorsoClaimType = {
    return: CrewClaimTypeEnum.return,
    warranty: CrewClaimTypeEnum.warranty,
    shippingProtection: 'Shipping_Protection', // using Title_Snake_Case to match other multi-word enum values
}; // otherwise, it can be specified as-is for some new non-enum value
export const corsoClaimTypeProgramName = {
    [CorsoClaimType.return]: crewClaimTypeEnumName[CorsoClaimType.return],
    [CorsoClaimType.warranty]: crewClaimTypeEnumName[CorsoClaimType.warranty],
    [CorsoClaimType.shippingProtection]: 'Shipping Protection',
    [DbJsonSchema.StoreUiConfig.WarrantyProgramName.guarantee]: 'Guarantee',
};
export const corsoClaimTypeProgramPluralName = {
    [CorsoClaimType.return]: crewClaimTypeEnumPluralizedName[CorsoClaimType.return],
    [CorsoClaimType.warranty]: crewClaimTypeEnumPluralizedName[CorsoClaimType.warranty],
    [CorsoClaimType.shippingProtection]: 'Shipping Protection',
    [DbJsonSchema.StoreUiConfig.WarrantyProgramName.guarantee]: 'Guarantees',
};
//# sourceMappingURL=corso.js.map